<!-- 基金从业考试专题首页 -->
<template>
    <div class="fundsFromIndex">
        <div class="section_1">
            <div class="left_section">
                <Slider ref="slider" :bannerlist="bannerlist" />
                <div class="count_down">
                    <p class="tips">距2021年<span>{{specialConfiguration.fundsFrom.name}}</span>考试</p>
                    <div class="days_box">
                        <div class="item" v-for="(item, index) in countDown" :key="index">{{item}}</div>
                    </div>
                </div>
                <div class="exam_time_box">
                    <div class="item">
                        <div class="item_name_time">
                            <div class="name" :class="{'active': applyItem.timeIsOver}">{{applyItem.name}}</div>
                            <div class="time">{{specialConfiguration.fundsFrom.applyDateStr}}</div>
                            <div class="circle" :class="{'active': applyItem.timeIsOver}">
                                <div class="inside_circle"></div>
                            </div>
                        </div>
                        <div class="action_box" :class="{'active': applyItem.timeIsOver}">
                            <div class="action_item" v-for="(item, index) in applyItem.list" :key="index">
                                <a @click="openDetails(item.id)">{{item.name}}</a>
                            </div>
                            <div class="triangle">
                                <img :src="require('@/common/images/special/triangle.png')" v-if="applyItem.timeIsOver" alt="">
                                <img :src="require('@/common/images/special/triangle_ash.png')" v-else alt="">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item_name_time">
                            <div class="name" :class="{'active': forReferenceItem.timeIsOver}">{{forReferenceItem.name}}</div>
                            <div class="time">核心考点解读</div>
                            <div class="circle" :class="{'active': forReferenceItem.timeIsOver}">
                                <div class="inside_circle"></div>
                            </div>
                        </div>
                        <div class="action_box" :class="{'active': forReferenceItem.timeIsOver}">
                            <div class="action_item" v-for="(item, index) in forReferenceItem.list" :key="index">
                                <a @click="openDetails(item.id)">{{item.name}}</a>
                            </div>
                            <div class="triangle">
                                <img :src="require('@/common/images/special/triangle.png')" v-if="forReferenceItem.timeIsOver" alt="">
                                <img :src="require('@/common/images/special/triangle_ash.png')" v-else alt="">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item_name_time">
                            <div class="name long" :class="{'active': examTicket.timeIsOver}">{{examTicket.name}}</div>
                            <div class="time">{{specialConfiguration.fundsFrom.admissionTicketDateStr}}</div>
                            <div class="circle" :class="{'active': examTicket.timeIsOver}">
                                <div class="inside_circle"></div>
                            </div>
                        </div>
                        <div class="action_box" :class="{'active': examTicket.timeIsOver}">
                            <div class="action_item" v-for="(item, index) in examTicket.list" :key="index">
                                <a @click="openDetails(item.id)">{{item.name}}</a>
                            </div>
                            <div class="triangle">
                                <img :src="require('@/common/images/special/triangle.png')" v-if="examTicket.timeIsOver" alt="">
                                <img :src="require('@/common/images/special/triangle_ash.png')" v-else alt="">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item_name_time">
                            <div class="name" :class="{'active': exam.timeIsOver}">{{exam.name}}</div>
                            <div class="time">{{specialConfiguration.fundsFrom.nextExamDateStr}}</div>
                            <div class="circle" :class="{'active': exam.timeIsOver}">
                                <div class="inside_circle"></div>
                            </div>
                        </div>
                        <div class="action_box" :class="{'active': exam.timeIsOver}">
                            <div class="action_item" v-for="(item, index) in exam.list" :key="index">
                                <a @click="openDetails(item.id)">{{item.name}}</a>
                            </div>
                            <div class="triangle">
                                <img :src="require('@/common/images/special/triangle.png')" v-if="exam.timeIsOver" alt="">
                                <img :src="require('@/common/images/special/triangle_ash.png')" v-else alt="">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item_name_time">
                            <div class="name" :class="{'active': checkScore.timeIsOver}">{{checkScore.name}}</div>
                            <div class="time">{{specialConfiguration.fundsFrom.checkGradeDateStr}}</div>
                            <div class="circle" :class="{'active': checkScore.timeIsOver}">
                                <div class="inside_circle"></div>
                            </div>
                        </div>
                        <div class="action_box" :class="{'active': checkScore.timeIsOver}">
                            <div class="action_item" v-for="(item, index) in checkScore.list" :key="index">
                                <a @click="openDetails(item.id)">{{item.name}}</a>
                            </div>
                            <div class="triangle">
                                <img :src="require('@/common/images/special/triangle.png')" v-if="checkScore.timeIsOver" alt="">
                                <img :src="require('@/common/images/special/triangle_ash.png')" v-else alt="">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item_name_time">
                            <div class="name long" :class="{'active': certificate.timeIsOver}">{{certificate.name}}</div>
                            <div class="time">{{specialConfiguration.fundsFrom.certificateDateStr}}</div>
                            <div class="circle" :class="{'active': certificate.timeIsOver}">
                                <div class="inside_circle"></div>
                            </div>
                        </div>
                        <div class="action_box" :class="{'active': certificate.timeIsOver}">
                            <div class="action_item" v-for="(item, index) in certificate.list" :key="index">
                                <a @click="openDetails(item.id)">{{item.name}}</a>
                            </div>
                            <div class="triangle">
                                <img :src="require('@/common/images/special/triangle.png')" v-if="certificate.timeIsOver" alt="">
                                <img :src="require('@/common/images/special/triangle_ash.png')" v-else alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="center_section">
                <div class="subject_name">
                    <div class="name">
                        {{specialConfiguration.fundsFrom.name}}考试
                    </div>
                    <!-- <div class="btn" @click="changeSubject" @mouseleave="mouseleaveChangeSubject" @mouseenter="mouseenterChangeSubject">
                        <img :src="!mouseChange ? require('@/common/images/personal/change.svg') : require('@/common/images/personal/change2.svg')" alt="">
                        切换科目
                    </div> -->
                </div>
                <div class="message_box" v-if="!informationListLoading">
                    <div class="message_section_item" v-for="(item, index) in informationList" :key="index">
                        <div class="title_box">
                            <div class="title_item" v-for="(obj, i) in item.sectioncontentlist" :key="i"><a @click="openUrl(obj)">{{obj.name}}</a></div>
                        </div>
                        <div class="sub_message_item" v-for="(obj, i) in item.tasklist" :key="i">
                            <div class="label_name" v-if="obj.name"><a @click="openLinkUrl(obj)">{{obj.name}}</a></div>
                            <div class="sub_message" v-for="(options, j) in obj.taskcontentlist" :key="j"><a @click="openUrl(options)">{{options.name}}</a></div>
                        </div>
                    </div> 
                </div>
                <div class="message_box" v-else>
                    <skeleton type='listcom' active :options="{row: 5, lineHight: 25}" />
                </div>
                <!-- 报考指导 -->
                <Message :messageName="'报考指导'" :icon="require('@/common/images/special/kszd.png')" :activeList="1" :loading="indexContentLoading" :isExam="false" :list="examGuidance" />
                <!-- 历年真题 -->
                <Message :messageName="'历年真题'" :icon="require('@/common/images/special/lnzt.png')" :activeList="2" :loading="indexContentLoading" :isExam="true" :list="pastExamPaper" />
            </div>
            <div class="right_section">
                <!-- 用户信息/登录组件 -->
                <UserMsg @openClockIn="openClockIn" ref="userMsg" />
                <!-- 题库信息板块 -->
                <div class="question_bank" @click="goQuestionBank">
                    <p class="title">基金从业资格考试题库</p>
                    <div class="item">
                        <div class="count_unit">
                            <div class="count">{{questionBank.ChapterPracticeCount}}</div>
                            <div class="unit">题</div>
                        </div>
                        <div class="label_name_tips">
                            <span class="label_name">章节练习</span>
                            <span class="tips">{{questionBank.ChapterPracticeCountTips}}</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="count_unit">
                            <div class="count">{{questionBank.previousExamPapersCount}}</div>
                            <div class="unit">题</div>
                        </div>
                        <div class="label_name_tips">
                            <span class="label_name">历年真题</span>
                            <span class="tips">{{questionBank.previousExamPapersTips}}</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="count_unit">
                            <div class="count">{{questionBank.simulatedTestPaperCount}}</div>
                            <div class="unit">题</div>
                        </div>
                        <div class="label_name_tips">
                            <span class="label_name">模拟真题</span>
                            <span class="tips">{{questionBank.simulatedTestPaperCountTips}}</span>
                        </div>
                    </div>
                    <div class="left_img">
                        <img :src="require('@/common/images/special/bg2_left.png')" alt="">
                    </div>
                </div>
                <!-- 学习榜单 -->
                <StudyTheList ref="studyTheList" :loading="studyTheListLoading" :list="studyTheList" />
            </div>
        </div>
        <!-- 广告位 -->
        <div class="advertising" v-if="advertising01.length">
            <div class="left">
                <img :src="advertising01[0].adurl" alt="" @click="openAdUrl(advertising01[0].clickurl)">
            </div>
            <div class="right">
                <img :src="advertising01[1].adurl" alt="" @click="openAdUrl(advertising01[1].clickurl)">
            </div>
        </div>
        <div class="section_2">
            <div class="left_section">
                <p class="title">备考指导</p>
                <div class="videoBox">
                    <!-- <video :src="require('@/common/images/special/mda-kj1s839hg704fcsg.mp4')" autoplay></video> -->
                    <video v-if="!isProductEnv" ref="video" src="http://innertest.img.capwhale.com/kmc/video/20201208/e31f8cb95301437a93db9bd983b848aa"></video>
                    <video v-if="isProductEnv" ref="video" src="https://cdn-v.capwhale.com/kmc/video/20201207/dc0639223e5d49ecb538fbab783ab0ce"></video>
                    
                    <div class="tips">
                        <div class="left_icon">
                            <img @click="playVideo" :src="require('@/common/images/special/play.png')" alt="">
                        </div>    
                        <div class="right_tips">基金从业资格基础课程</div>
                    </div>
                </div>
                <div class="btn_box">
                    <div @click="freeListen">免费试听</div>
                    <div @click="moreCourse">更多课程</div>
                </div>
                <div class="course" v-if="!indexContentLoading">
                    <div class="item" v-for="(item, index) in course" :key="index">
                        <div class="circle" :class="{'top_three': index < 3}"></div>
                        <div class="course_name" :class="{'top_three': index < 3}"><a :href="item.url">{{item.subject}}</a></div>
                    </div>
                </div>
                <skeleton type='listcom' v-else active :options="{row: 13, lineHight: 20}" />
            </div>
            <div class="center_section">
                <!-- 模拟试题 -->
                <Message :messageName="'模拟试题'" :icon="require('@/common/images/special/mnst.png')" :activeList="3" :loading="indexContentLoading" :isExam="true" :list="mockTest" />
                <!-- 易错题 -->
                <Message :messageName="'易错题'" :icon="require('@/common/images/special/yct.png')" :activeList="4" :loading="indexContentLoading" :isExam="true" :list="easyWrongtopic" />
            </div>
            <div class="right_section">
                <!-- 资料下载版块 -->
                <DataDownload ref="dataDownload" :loading="dataDownloadLoading" :list="dataDownload" />
                <!-- 热门推荐版块 -->
                <Recommend ref="recommend" :loading="recommendLoading" :list="recommendList" />
            </div>
        </div>
        <!-- 广告位 -->
        <div class="advertising" v-if="advertising02.length">
            <div class="left">
                <img :src="advertising02[0].adurl" alt="" @click="openAdUrl(advertising02[0].clickurl)">
            </div>
            <div class="right">
                <img :src="advertising02[1].adurl" alt="" @click="openAdUrl(advertising02[1].clickurl)">
            </div>
        </div>
        <clockIn examcode="jjcy" ref="clockIn" />
    </div>
</template>

<script>
import Slider from './components/slider'
import Message from './components/message'
import UserMsg from './components/userMsg'
import StudyTheList from './components/studyTheList'
import DataDownload from './components/dataDownload'
import Recommend from './components/recommend'
import clockIn from '../components/clockIn'
import {mapGetters, mapActions} from 'vuex'
import {getQuestionBankTopicIndexsection, getIndexRecommendContentList, getIndexContentList, getDocumentList, getStudyRankList} from 'api/special'
import {getAdConfig} from 'api/systemApi'
export default {
    metaInfo: {
        title: '2023基金从业资格考试_考点解读_鲸融课堂_鲸融网', // set a title
        meta: [
            {                 // set meta
                name: 'keywords',
                content: '基金从业资格培训,基金从业考试视频,基金从业辅导,基金真题答案,基金章节经典真题,基金真题答案辅导,基金题库闯关,基金考试出题6大套路,模拟卷在线刷,鲸融网,鲸融课堂,资鲸网,资鲸课堂'
            },
            {                 // set meta
                name: 'description',
                content: '鲸融课堂-基金从业资格考试网提供2021年基金从业资格考试报名时间，报名入口，成绩查询，准考证打印，考试时间，报名条件，考试大纲，考试教材，考试试题、历年真题、考试教材等考试信息，力求打造最优质的课程，帮助广大考生节约时间、高效备考！'
            }
        ]
    },
    data() {
        return {
            bannerlist: [],
            countDown: [],
            applyItem: {
                name: '报名',
                list: [
                    {name: '新手指南', url: '', id: 'ST000001'},
                    {name: '报考答疑', url: '', id: 'ST000002'},
                    {name: '报考条件', url: '', id: 'ST000003'},
                    {name: '新人礼包', url: '', id: 'ST000004'},
                    {name: '科目选择', url: '', id: 'ST000005'},
                    {name: '有奖征文', url: '', id: 'ST000006'}
                ],
                timeIsOver: false
            },
            forReferenceItem: {
                name: '备考',
                list: [
                    {name: '辅导笔记', url: '', id: 'ST000007'},
                    {name: '历年真题', url: '', id: 'ST000008'},
                    {name: '干货笔记', url: '', id: 'ST000009'}
                ],
                timeIsOver: false
            },
            examTicket: {
                name: '准考证',
                list: [
                    {name: '打印入口', url: '', id: 'ST000010'},
                    {name: '打印时间', url: '', id: 'ST000011'},
                    {name: '考场规则', url: '', id: 'ST000012'},
                ],
                timeIsOver: false
            },
            exam: {
                name: '考试',
                list: [
                    {name: '考试时间', url: '', id: 'ST000013'},
                    {name: '题型题量', url: '', id: 'ST000014'},
                    {name: '资料下载', url: '', id: 'ST000015'},
                ],
                timeIsOver: false
            },
            checkScore: {
                name: '查分',
                list: [
                    {name: '查询时间', url: '', id: 'ST000016'},
                    {name: '查分入口', url: '', id: 'ST000017'},
                    {name: '有效期', url: '', id: 'ST000018'},
                ],
                timeIsOver: false
            },
            certificate: {
                name: '合格证',
                list: [
                    {name: '证书领取', url: '', id: 'ST000019'},
                    {name: '证书注册', url: '', id: 'ST000020'},
                    {name: '继续教育', url: '', id: 'ST000021'},
                ],
                timeIsOver: false
            },
            informationList: [],
            examGuidance: [],
            pastExamPaper: [],
            questionBank: {
                ChapterPracticeCount: 6402, // 章节练习数
                ChapterPracticeCountTips: '—分知识点顺序练习', // 章节练习描述
                previousExamPapersCount: 4449, // 历年真题数
                previousExamPapersTips: '—摸清出题思路、方向、趋势', // 历年真题描述
                simulatedTestPaperCount: 33, // 模拟试题数
                simulatedTestPaperCountTips: '—系统智能评分' // 模拟试题描述
            },
            studyTheList: [],
            course: [],
            mockTest: [],
            easyWrongtopic: [],
            dataDownload: [],
            dataDownloadLoading: true,
            recommendList: [],
            mouseChange: false,
            informationListLoading: true,
            recommendLoading: true,
            indexContentLoading: true,
            studyTheListLoading: true,
            adcode01: 'TJJ01', // 基金从业考试-PC-首页-左上
            adcode02: 'TJJ02', // 基金从业考试-PC-首页-中部2个
            adcode03: 'TJJ03', // 基金从业考试-PC-首页-底部2个
            advertising01: [],
            advertising02: [],
            isplay: false,
            isProductEnv:false//是否是生产环境
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getDaysBetween(new Date(), this.specialConfiguration.fundsFrom.nextExamDate)
        this.getQuestionBankTopicIndexsection()
        this.calculateTime()
        // for(let i = 0; i < 3; i++) {
        //     this.getAdConfig()
        // }
        this.getAdConfig(this.adcode01)
        this.getAdConfig(this.adcode02)
        this.getAdConfig(this.adcode03)
        if(location.hostname.indexOf('capwhale.com')>=0 ||
            location.hostname.indexOf('zj178.com')>=0){
            this.isProductEnv = true
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
    },
    methods: {
        playVideo() {
            if (!this.isplay) {
                this.isplay = true
                this.$refs.video.play()
            } else {
                this.isplay = false
                this.$refs.video.pause()
            }
            // console.log(this.$refs.video)
        },
        openClockIn() {
            this.$refs.clockIn.open()
        },
        moreCourse() {
            window.open(`${location.origin}/search?catecode=02&typeData=0201&token=${this.user.loginToken}`)
        },
        freeListen() {
            window.open(`${location.origin}/coursedetails?cid=ACY0vVlcV4YUkC8s&token=${this.user.loginToken}&chid=`)
        },
        openUrl(obj) {
            console.log(obj)
            if (obj.contenttype === 2) {
                window.open(obj.linkurl)
            } else {
                window.open(`${location.origin}/messageDetails?contentid=${obj.contentid}&token=${this.user.loginToken}`)
            }
        },
        openLinkUrl(obj) {
            if (obj.linkurl) {
                window.open(obj.linkurl)
            }
        },
        openDetails(id) {
            window.open(`${location.origin}/messageDetails?contentid=${id}&token=${this.user.loginToken}`)
        },        
        openAdUrl(url) {
            if(url){
                window.open(url)
            }
        },
        // 获取广告配置接口
        getAdConfig(id) {
            getAdConfig({
                data: {adcode: id},
                success: res => {
                    this.advertisingLoading = false
                    if (id === 'TJJ01') {
                        this.bannerlist = res.data.content
                    } else if (id === 'TJJ02') {
                        this.advertising01 = res.data.content
                    } else if (id === 'TJJ03') {
                        this.advertising02 = res.data.content
                    }
                },
                error: res => {
                    this.advertisingLoading = false
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取学习榜单
        getStudyRankList() {
            getStudyRankList({
                data: {examcode: 'jjcy'},
                success: res => {
                    this.studyTheListLoading = false
                    this.studyTheList = res.data.content
                },
                error: res => {
                    this.studyTheListLoading = false
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取资料列表
        getDocumentList() {
            getDocumentList({
                data: {examcode: 'jjcy'},
                success: res => {
                    this.dataDownloadLoading = false
                    this.dataDownload = res.data.content
                    console.log(res)
                },
                error: res => {
                    this.dataDownloadLoading = false
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取推荐列表
        getIndexRecommendContentList() {
            getIndexRecommendContentList({
                data: {examcode: 'jjcy'},
                success: res => {
                    this.recommendLoading = false
                    this.recommendList = res.data.content
                    console.log(this.recommendList, this.recommendLoading)
                },
                error: res => {
                    this.recommendLoading = false
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取各版块资讯列表
        getIndexContentList() {
            getIndexContentList({
                data: {examcode: 'jjcy'},
                success: res => {
                    this.indexContentLoading = false
                    this.examGuidance = res.data.zdlist
                    this.pastExamPaper = res.data.ztlist
                    this.mockTest = res.data.mnstlist
                    this.easyWrongtopic = res.data.yctlist
                    this.course = res.data.bkzdlist
                    console.log(res)
                },
                error: res => {
                    this.indexContentLoading = false
                    this.$message.error(res.msg)
                }
            })
        },
        getDaysBetween(dateString1,dateString2){
            var startDate = Date.parse(dateString1)
            var endDate = Date.parse(dateString2)
            var days = Math.ceil((endDate - startDate)/(1*24*60*60*1000))
            this.countDown = String(days).split('')
            console.log(this.countDown, days)
        },
        changeSubject() {

        },
        mouseenterChangeSubject() {
            // if (this.changeShowlistBox) {
            //     clearTimeout(this.changeShowlistBox)
            // }
            this.mouseChange = true
        },
        mouseleaveChangeSubject() {
            this.mouseChange = false
        },
        // 去题库
        goQuestionBank() {
            this.$router.push({
                name: 'StartTopic'
            })
        },
        // 顶部考试首页推荐信息
        getQuestionBankTopicIndexsection() {
            this.setLoading(true)
            getQuestionBankTopicIndexsection({
                data: {examcode: 'jjcy'},
                success: res => {
                    this.setLoading(false)
                    this.informationList = res.data.content
                    this.informationListLoading = false
                    this.getIndexRecommendContentList()
                    this.getIndexContentList()
                    this.getDocumentList()
                    this.getStudyRankList()
                    // this.getAdConfig()
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 判断当前时间和考试时间
        calculateTime() {
            const currentTime = new Date().getTime()
            const applyItemTime = new Date(this.specialConfiguration.fundsFrom.applyBeginDate).getTime()
            // const forReferenceItemTime = new Date(this.specialConfiguration.fundsFrom.admissionTicketBeginDate).getTime()
            const examTicketTime = new Date(this.specialConfiguration.fundsFrom.admissionTicketBeginDate).getTime()
            const examTime = new Date(this.specialConfiguration.fundsFrom.nextExamDate).getTime()
            const checkScoreTime = new Date(this.specialConfiguration.fundsFrom.checkGradeBeginDate).getTime()
            const certificateTime = new Date(this.specialConfiguration.fundsFrom.certificateBeginDate).getTime()
            // if (applyItemTime - currentTime <= 0) {
            this.applyItem.timeIsOver = true
            // }
            if (examTicketTime - currentTime <= 0) {
                this.examTicket.timeIsOver = true
            }
            if (examTime - currentTime <= 0) {
                this.exam.timeIsOver = true
            }
            if (checkScoreTime - currentTime <= 0) {
                this.checkScore.timeIsOver = true
            }
            if (certificateTime - currentTime <= 0) {
                this.certificate.timeIsOver = true
            }
            console.log(currentTime, applyItemTime)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'specialConfiguration',
            'user'
        ])
    },
    components: {
        Slider,
        Message,
        UserMsg,
        StudyTheList,
        DataDownload,
        Recommend,
        clockIn
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .PHome {
        background: #fff;
    }
    .fundsFromIndex {
        width: 1050px;
        margin: auto;
        // margin-top: 80px;
        padding-top: 20px;
        .section_1 {
            display: flex;
            margin-bottom: 16px;
            .left_section {
                width: 260px;
                margin-right: 20px;
                .count_down {
                    margin-top: 24px;
                    width: 260px;
                    height: 108px;
                    background: url('../../../common/images/special/bg1.png');
                    background-size: 100%;
                    margin-bottom: 20px;
                    .tips {
                        text-align: center;
                        font-size: 14px;
                        line-height: 20px;
                        span {
                            color: #409EFF;
                        }
                    }
                    .days_box {
                        margin-top: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .item {
                            width: 36px;
                            height: 43px;
                            background: url('../../../common/images/special/bg5.png');
                            background-size: 100%;
                            margin-right: 3px;
                            text-align: center;
                            line-height: 43px;
                            color: #fff;
                            font-size: 30px;
                            font-weight: bold;
                        }
                    }
                }
                .exam_time_box {
                    padding: 20px 0 10px 10px;
                    border: 1px dashed #E5E5E5;
                    border-right: none;
                    .item {
                        position: relative;
                        margin-bottom: 18px;
                        .item_name_time {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .name {
                                width: 88px;
                                height: 24px;
                                background: url('../../../common/images/special/bg4.png');
                                background-size: 100%;
                                padding-left: 13px;
                                box-sizing: border-box;
                                font-size: 16px;
                                line-height: 24px;
                                margin-bottom: 5.5px;
                                &.active {
                                    background: url('../../../common/images/special/bg_active.png');
                                    color: #fff;
                                    background-size: 100%;
                                }
                                &.long {
                                    width: 100px;
                                    background: url('../../../common/images/special/bg_long.png');
                                    background-repeat: no-repeat;
                                    &.active {
                                        background-repeat: no-repeat;
                                        background: url('../../../common/images/special/bg_long_active.png');
                                        color: #fff;
                                        background-size: 100% 24px;
                                    }
                                }
                            }
                            .time {
                                font-size: 14px;
                                color: #E13B29;
                            }
                            .circle {
                                position: absolute;
                                width: 15px;
                                height: 15px;
                                border-radius: 50%;
                                border: 1px solid #E5E5E5;
                                box-sizing: border-box;
                                top: 5px;
                                left: -17px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                .inside_circle {
                                    width: 5px;
                                    height: 5px;
                                    border-radius: 50%;
                                    background: #E5E5E5;
                                }
                                &.active {
                                    border-color: #409EFF;
                                    .inside_circle {
                                        background: #409EFF;
                                    }
                                }
                            }
                        }
                        .action_box {
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            padding: 15px 20px 5px;
                            background: #F8F8F8;
                            border: 1px solid #E5E5E5;
                            justify-content: space-between;
                            position: relative;
                            margin-top: 8px;
                            &.active {
                                background: #E9F4FF;
                                border-color: #D7EAFF;
                            }
                            .action_item {
                                width: 56px;
                                margin-bottom: 10px;
                                cursor: pointer;
                                a {
                                    &:hover {
                                        color: #409EFF;
                                    }
                                }
                            }
                            .triangle {
                                position: absolute;
                                top: -8px;
                                left: 20px;
                                img {
                                    width: 10px;
                                    height: 8px;
                                }
                            }
                        }
                    }
                }
            }
            .center_section {
                width: 490px;
                margin-right: 20px;
                .subject_name {
                    // width: ;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    background: #FFF5F3;
                    margin-bottom: 12px;
                    padding: 0 12px 0 10px;
                    box-sizing: border-box;
                    .name {
                        line-height: 40px;
                        color: #E13B29;
                        font-size: 18px;
                        font-weight: bold;
                    }
                    .btn {
                        width: 92px;
                        height: 28px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 1px solid #E5E5E5;
                        border-radius: 4px;
                        font-size: 14px;
                        background: #fff;
                        img {
                            margin-right: 4px;
                        }
                        &:hover {
                            color: #409EFF;
                            border-color: #409EFF;
                        }
                    }
                }
                .message_box {
                    height: 218px;
                    overflow: hidden;
                    .message_section_item {
                        &:not(:first-of-type) {
                            padding-top: 8px;
                        }
                        .title_box {
                            display: flex;
                            align-items: center;
                            width: 100%;
                            overflow: hidden;
                            margin-bottom: 12px;
                            .title_item {
                                // min-width: 50px;
                                font-size: 18px;
                                line-height: 25px;
                                // overflow: hidden;
                                // text-overflow: ellipsis;
                                white-space: nowrap;
                                color: #E13B29;
                                a {
                                    color: #E13B29;
                                    font-weight: bold;
                                    cursor: pointer;
                                }
                                &:not(:last-of-type) {
                                    margin-right: 12px;
                                }
                            }
                        }
                        .sub_message_item {
                            display: flex;
                            align-items: center;
                            width: 100%;
                            overflow: hidden;
                            margin-bottom: 12px;
                            .label_name {
                                font-size: 14px;
                                padding-right: 10px;
                                border-right: 1px solid #E5E5E5;
                                line-height: 20px;
                                white-space: nowrap;
                                a {
                                    color: #999999;
                                    cursor: pointer;
                                }
                            }
                            .sub_message {
                                // min-width: 50px;
                                font-size: 14px;
                                line-height: 20px;
                                // overflow: hidden;
                                // text-overflow: ellipsis;
                                white-space: nowrap;
                                &:not(:first-of-type) {
                                    margin-left: 12px;
                                }
                                a {
                                    color: #333333;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                    .listCom_2QHM1mDh {
                        padding: 0;
                    }
                }
            }
            .right_section {
                width: 260px;
                .question_bank {
                    width: 100%;
                    margin: 20px 0 20px;
                    height: 280px;
                    background-image: url('../../../common/images/special/bg2.png');
                    background-size: 100% 280px;
                    padding: 18px 20px 20px 40px;
                    position: relative;
                    box-sizing: border-box;
                    background-repeat: no-repeat;
                    cursor: pointer;
                    .title {
                        text-align: center;
                        font-size: 16px;
                        line-height: 22px;
                        font-weight: bold;
                    }
                    .item {
                        // padding-bottom: 20px;
                        // padding-left: 20px;
                        padding-top: 20px;
                        // border-left: 1px solid #E5E5E5;
                        .count_unit {
                            display: flex;
                            align-items: center;
                            .count {
                                font-size: 20px;
                                font-weight: bold;
                                line-height: 28px;
                                margin-right: 8px;
                            }
                            .unit {
                                width: 24px;
                                height: 20px;
                                border-radius: 10px 10px 10px 0;
                                background: #F1E1D0;
                                font-size: 12px;
                                color: #6D5445;
                                text-align: center;
                                line-height: 20px;
                                font-weight: bold;
                            }
                        }
                        .label_name_tips {
                            line-height: 20px;
                            .label_name {
                                font-size: 14px;
                                margin-right: 5px;
                                font-weight: bold;
                            }
                            .tips {
                                font-size: 12px;
                                color: #999999;
                                font-weight: bold;
                            }
                        }
                    }
                    .left_img {
                        position: absolute;
                        top: 69px;
                        left: 20px;
                        img {
                            width: 10px;
                            height: 162px;
                        }
                    }
                }
            }
        }
        .advertising {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .left {
                width: 770px;
                height: 80px;
                margin-right: 20px;
                img {
                    width: 770px;
                    height: 80px;
                }
            }
            .right {
                width: 260px;
                height: 80px;
                img {
                    width: 260px;
                    height: 80px;
                }
            }
        }
        .section_2 {
            display: flex;
            margin-bottom: 10px;
            margin-right: 20px;
            .left_section {
                width: 260px;
                margin-right: 20px;
                .title {
                    font-size: 18px;
                    line-height: 23px;
                    border-left: 3px solid #409EFF;
                    padding-left: 5px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                .videoBox {
                    width: 260px;
                    height: 146px;
                    position: relative;
                    margin-bottom: 16px;
                    cursor: pointer;
                    video {
                        width: 260px;
                        height: 146px;
                    }
                    .tips {
                        display: flex;
                        align-items: center;
                        position: absolute;
                        width: 100%;
                        left: 0;
                        bottom: 0;
                        height: 40px;
                        background: rgba($color: #000000, $alpha: 0.5);
                        // opacity: 0;
                        // transition: opacity 0.3s;
                        .left_icon {
                            width: 40px;
                            height: 40px;
                            background: linear-gradient(180deg, #74CDFF 0%, #409EFF 100%);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img {
                                width: 20px;
                                height: 20px;
                            }
                        }
                        .right_tips {
                            flex: 1;
                            color: #fff;
                            font-size: 14px;
                            line-height: 40px;
                            padding-left: 12px;
                            box-sizing: border-box;
                        }
                    }
                    // &:hover {
                    //     .tips {
                    //         opacity: 1;
                    //     }
                    // }
                }
                .btn_box {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    &>div {
                        flex: 1;
                        background: #F8F8F8;
                        height: 35px;
                        text-align: center;
                        line-height: 35px;
                        font-size: 14px;
                        cursor: pointer;
                        &:hover {
                            color: #409EFF;
                        }
                    }
                    &>div:not(:last-of-type) {
                        margin-right: 12px;
                    }
                }
                .course {
                    height: 440px;
                    .item {
                        display: flex;
                        align-items: center;
                        height: 20px;
                        &:not(:last-of-type) {
                            margin-bottom: 15px;
                        }
                        .circle {
                            width: 6px;
                            height: 6px;
                            border-radius: 50%;
                            background: #999999;
                            margin-right: 10px;
                            &.top_three {
                                background: #E13B29;
                            }
                        }
                        .course_name {
                            width: 238px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            cursor: pointer;
                            a {
                                color: #333333;
                            }
                            &.top_three {
                                a {
                                    color: #E13B29;
                                }
                            }
                        }
                        &:hover {
                            a {
                                color:#E13B29;
                            }
                            .circle {
                                background: #E13B29;
                            }
                        }
                    }
                }
                .contianer_S8Y9lJLI {
                    height: 440px;
                }
            }
            .center_section {
                width: 640px;
                margin-right: 20px;
            }
            .right_section {
                width: 260px;
            }
        }
    }
</style>